import './map.css';
import {useCallback, useState} from "react";
import {GoogleMap, useJsApiLoader} from "@react-google-maps/api";

const ReactMap = (
    {
        height = '100%',
        center = {
            lat: 13.028753,
            lng: 77.584400
        },
        zoom = 16,
        children
    }
) => {
    // .... default options .....
    const OPTIONS = {
        mapTypeControl: false,
        streetViewControl: false,
        fullscreenControl: false
    }
    const containerStyle = {
        width: '100%',
        height: '100%'
    };
    const [map, setMap] = useState(null);

    const { isLoaded } = useJsApiLoader({
        id: 'google-map-script',
        googleMapsApiKey: "AIzaSyCyqGWfLjwQjvkmSoyS98ptW3fIrG_Ytio"
    })
    const onLoad = useCallback(function callback(map) {
        // This is just an example of getting and using the map instance!!! don't just blindly copy!

    }, [])
    const onUnmount = useCallback(function callback(map) {
        setMap(null)
    }, [])

    return (
        isLoaded ? (
            <>
                {/*<button className={'btn'} onClick={AddMarkers}>Add Markers</button>*/}
                <GoogleMap
                    options = {OPTIONS}
                    mapContainerStyle={containerStyle}
                    center={center}
                    zoom={zoom}
                    onLoad={onLoad}
                    onUnmount={onUnmount}>
                    {
                        children
                    }
                </GoogleMap>
            </>
        ) : <>
        <div className="">Not loaded</div>
        </>
    )
}

export default ReactMap;
